if (!customElements.get("product-gallery-modal")) {
  customElements.define(
    "product-gallery-modal",
    class ProductGalleryModal extends ModalDialog {
      constructor() {
        super();

        this.slider = this.querySelector("slider-component");
        this.tip = this.querySelector(".modal-tip");
        this.boundOnKeyDown = this.onKeyDown.bind(this);
        this.addEventListener("keydown", this.boundOnKeyDown);
      }

      disconnectedCallback() {
        this.removeEventListener("keydown", this.boundOnKeyDown);
      }

      show(opener) {
        super.show(opener);
        setTimeout(() => {
          // 弹窗打开后重新初始化 slider
          this.slider.reInstall();

          this.showActiveMedia();
        }, 50);

        // 显示操作提示
        if (this.timer) clearTimeout(this.timer);
        if (this.tip) {
          this.tip.classList.add("active");
          this.timer = setTimeout(() => {
            this.tip.classList.remove("active");
          }, 5000);
        }
      }

      hide() {
        this.resetMediaState();
        super.hide();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        if (!mediaId) return;

        if (this.slider && this.slider.initSliderStatus) {
          this.syncVisibleMedia(mediaId);

          const currentSlideElement = this.slider.querySelector(
            `.slider-slide[data-media-id='${mediaId}']`,
          );
          if (!currentSlideElement) return;

          this.slider.slideByElement(currentSlideElement);

          const deferredMedia =
            currentSlideElement.querySelector(".deferred-media");
          if (deferredMedia) {
            deferredMedia.loadContent();
          }
        }
      }

      syncVisibleMedia(mediaId) {
        if (!this.hasAttribute("data-hide-variants")) return;

        this.querySelectorAll(".is-current-variant-media").forEach((element) =>
          element.classList.remove("is-current-variant-media"),
        );
        this.querySelectorAll(".is-current-variant-media-group").forEach((element) =>
          element.classList.remove("is-current-variant-media-group"),
        );

        const currentSlideElement = this.querySelector(
          `.slider-slide[data-media-id='${mediaId}']`,
        );
        if (!currentSlideElement) return;

        currentSlideElement.classList.add("is-current-variant-media");

        const groupName = currentSlideElement.dataset.mediaGroup;
        if (groupName) {
          this.querySelectorAll(`[data-media-group='${groupName}']`).forEach(
            (element) => {
              element.classList.add("is-current-variant-media-group");
            },
          );
        }

        this.slider.reInstall();
      }

      resetMediaState() {
        this.querySelectorAll("image-zoom-drag, image-zoom-hold").forEach(
          (zoomableMedia) => {
            if (typeof zoomableMedia.reset === "function") {
              zoomableMedia.reset();
            }
          },
        );
      }

      onKeyDown(event) {
        if (!this.hasAttribute("open") || !this.slider?.initSliderStatus) return;

        const target = event.target;
        if (
          target instanceof HTMLElement &&
          target.closest('input, textarea, select, [contenteditable="true"]')
        ) {
          return;
        }

        const key = event.code ? event.code.toUpperCase() : "";
        if (key === "ARROWLEFT") {
          event.preventDefault();
          this.slider.slideByDirection("previous");
        } else if (key === "ARROWRIGHT") {
          event.preventDefault();
          this.slider.slideByDirection("next");
        }
      }
    },
  );
}
